/**
 * Well-known system tag names that the server applies to conversations
 * automatically. Lives in redo-model (rather than @redotech/support-db-util)
 * so frontend packages can reference them too — e.g. when filtering the
 * conversations table by a system tag.
 */

/** System tag name applied to conversations initiated by Text Concierge. */
export const TEXT_CONCIERGE_TAG_NAME = "Text Concierge Initiated";

/** System tag name applied when the AI agent escalates a conversation to a human. */
export const AI_NEEDS_HELP_TAG_NAME = "AI_NEEDS_HELP";

/** System tag name applied when the AI agent flags a conversation as spam / no-reply. */
export const SPAM_TAG_NAME = "SPAM";

/** System tag name that excludes a conversation/ticket (and its CSAT) from analytics. */
export const EXCLUDE_ANALYTICS_TAG_NAME = "exclude analytics";

/**
 * @deprecated Use the top-level constants above for supportV2 code. These enum
 * values target the legacy MongoDB `Conversation.tagIds` pipeline; supportV2
 * `shopper_ai_tag` rows use the new strings.
 */
export enum AIConversationTag {
  NEEDS_HELP = "ai:needs_help",
  SPAM = "ai:no_reply",
  BRACKETING_DETECTED = "ai:bracketing_detected",
  UNTAGGED = "UNTAGGED",
}
